import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

function Shipping() {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Logo at the top */}
        <div className="text-center mb-8">
          <Link to="/" className="inline-block">
            <img 
              src="/assets/images/logo.png" 
              alt="Atelier Ambre" 
              className="h-32 w-auto mx-auto hover:opacity-80 transition-opacity"
            />
          </Link>
        </div>
        
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Verzending en retour
          </h1>
        </div>

        <div className="bg-white rounded-lg shadow-md p-8 max-w-3xl mx-auto">
          <div className="prose prose-lg max-w-none">
            <h2 className="text-2xl font-semibold text-gray-900 mb-6">Verzendingskost</h2>
            <p className="text-gray-700 mb-4">
              Alle kaartjes worden via brievenpost opgestuurd naar jou. Daarvoor rekenen we een standaardkost van <strong>3,49 euro per verzending</strong> aan, die automatisch verrekend wordt bij de check-out.
            </p>
            <p className="text-gray-700 mb-4">
              Koop je meerdere kaartjes? Goed nieuws, want de verzendingskost blijft dezelfde!
            </p>
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
              <p className="text-yellow-800">
                <strong>Opgelet:</strong> omdat we enkel met brievenpost werken, kunnen we je helaas geen track-and-trace bieden. Je ontvangt wel een bevestigingsmail zodra je bestelling betaald is en eentje wanneer je kaartjes met de post verstuurd werden. Liep er toch iets mis? Bekijk de garantievoorwaarden hieronder.
              </p>
            </div>

            <h2 className="text-2xl font-semibold text-gray-900 mb-6">Levertermijn</h2>
            <p className="text-gray-700 mb-4">
              Bestellingen worden via Bpost verstuurd, dus reken op zo'n <strong>4 tot 6 werkdagen</strong> voordat je kaartjes in je brievenbus zitten.
            </p>
            <p className="text-gray-700 mb-6">
              Heb je na meer dan een week nog niets ontvangen? Stuur dan een mailtje met je order gegevens.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mb-6">Foutje in adresgegevens?</h2>
            <p className="text-gray-700 mb-6">
              Gaf je per ongeluk een fout adres op? Stuur zo snel mogelijk een mail met je juiste adresgegevens naar{' '}
              <a href="mailto:hallo@atelierambree.be" className="text-ambre-600 hover:text-ambre-700 underline">
                hallo@atelierambree.be
              </a>{' '}
              zodat we de verzending nog kunnen proberen aanpassen.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mb-6">Garantie</h2>
            <p className="text-gray-700 mb-4">
              We doen ons stinkende best om ervoor te zorgen dat jouw bestelling goed en wel bij jou toekomt, maar het kan altijd gebeuren dat er onderweg iets misloopt.
            </p>
            <p className="text-gray-700 mb-4">
              Is je bestelling beschadigd of onvolledig geleverd? Is je bestelling spoorloos en helemaal niet aangekomen? Dan kun je aanspraak maken op garantie.
            </p>
            <p className="text-gray-700 mb-6">
              Als je ons binnen de <strong>14 dagen</strong> na constatering van het gebrek op de hoogte brengt via{' '}
              <a href="mailto:hallo@atelierambree.be" className="text-ambre-600 hover:text-ambre-700 underline">
                hallo@atelierambree.be
              </a>
              , zullen wij kosteloos zorgen voor vervanging van het product. Als het niet meer binnen de wettelijke termijn van 14 dagen valt, kunnen we je helaas niet meer helpen.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mb-6">Niet helemaal tevreden?</h2>
            <p className="text-gray-700 mb-4">
              Ben je toch niet helemaal tevreden over de kaartjes die je kocht? Als klant heb je het recht om je bestelling binnen een termijn van <strong>14 kalenderdagen</strong> zonder opgave van reden te retourneren of om te ruilen.
            </p>
            <p className="text-gray-700 mb-4">
              In dat geval stuur je een mail naar{' '}
              <a href="mailto:hallo@atelierambree.be" className="text-ambre-600 hover:text-ambre-700 underline">
                hallo@atelierambree.be
              </a>{' '}
              om ons op de hoogte te brengen.
            </p>
            <p className="text-gray-700 mb-6">
              De kosten voor het retourneren of omruilen zijn voor eigen rekening. Zorg ervoor dat je bestelling onbeschadigd is en in zijn oorspronkelijke staat en verpakking geretourneerd wordt. Het retouradres zal je via mail ontvangen zodra je ons op de hoogte bracht van je beslissing tot retourneren of omruilen.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mb-6">Productinformatie</h2>
            <p className="text-gray-700 mb-2">• Ongevouwen kaart met blanco achterzijde, A6-formaat (105 x 148 mm)</p>
            <p className="text-gray-700 mb-2">• Gedrukt op kwaliteitsvol papier met een subtiele lijnstructuur (300 gram/m²)</p>
            <p className="text-gray-700">• Inclusief bruine envelop gemaakt van gerecycleerd papier (C6-formaat)</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Shipping;